window.sr = new scrollReveal({
	mobile: true
});

$(document).ready(function() {	

	var doregister = function(e) {

		e.preventDefault();
		$('.login-error, .register-error').css('display', 'none');
		$('#register-action').text('Please Wait...');
		var data = {
			  email                 : $('#email_register').val()
			, username              : $('#username_register').val()
			, password              : $('#password_register').val()
			, password_confirmation : $('#password_confirmation_register').val()
			, plan_id               : $('#plan_id').val()
			, terms                 : true
		}
		$.ajaxSetup({ 
			headers: { 'X-CSRF-TOKEN' :  $('#_token').val() } 
		});

		$(".password").val($('#password_register').val());
		$.ajax({
			type : 'POST'
			, url  : '/api/account/register'
			, data : data
			, success : function(data) {
				toastr.success('You are now registered!', 'Registration');
				$("#popup-signup").hide();
				$(".popup-payment").show();
				console.log(data);
				localStorage.setItem('user_id', data.response.data.id);
				// $("#plan_name").val(data.plan.name);
				// $(".plan_id").val(data.plan.id);
				// $("#plan_price").val(data.plan.price);
				// $("#plan_bill_every_number").val(data.plan.bill_every_number);
				// $("#plan_bill_every_date").val(data.plan.bill_every_date);
				$(".user_id").val(data.response.data.id);
				$(".username").val(data.response.data.username);
				$("#email").val(data.response.data.email);
				var password = $('#password_register').val();
				$(".password").val(password);
				

				$(".popup-payment").trigger('cl.modal.show');
			}
			, error : function(error) {
				$('.register-error').fadeIn();
				$('#email').focus();
				$('#register-action').text('Join Now');
				var messages = '';
				_.each(error.responseJSON.response.message, function(str) {
					messages += str + "<br/>";
				});
				$('#register-error-messages').html(messages);
			}
		});
	}

	$('#quick_register').on('submit', doregister);
	$('#register-action').on('click', doregister);
	$('#email_register, #password_register').on('keyup', function() { $('.register-error').fadeOut(); });

	var dologin = function(e) {
		if (e) {
			e.preventDefault();
		}
		$('.login-error, .register-error').css('display', 'none');
		$('#login-action').text('Signing In...');
		var data = {
			email : $('#email').val()
			, password : $('#password').val()
		}
		$.ajax({
			type : 'POST'
			, url : '/auth/login'
			, data : data
			, success : function(data) {
				var sub_id = jQuery('#sub_id').val();
				var code = jQuery('#code').val();
				if(sub_id){
					window.location.href = '/order/payment?sub_id='+sub_id;
				}else if(code){
					window.location.href = '/account/signup-freetrial?code='+code;
				}else{
					window.location.href = '/account';
				}
			}
			, error : function(error) {
				$('.login-error').fadeIn();
				$('#email').focus();
				$('#login-action').text('Sign In');
			}
		});
	}

	$('#login-form').on('submit', dologin);
	$('#login-action').on('click', dologin);
	$('#email, #password').on('keyup', function(e) { 
		$('.login-error').fadeOut(); 
		if (e.which == 13 || e.keyCode == 13) {
			dologin.call();
		}
	});

	header();
	
	$('.show-pop').click(function(e){
		e.preventDefault();
		$('.login-error, .register-error').css('display', 'none');
		var i = $(this).attr('data-pop');
			l = $('#'+i);
		$('.popup, .popup-box').hide();
		$('.popup').attr('data-pop', i).fadeIn();
		l.css({
		  'top':'50%',
		  'margin-top': '-'+ l.height()/2 +'px'
			})
		 .fadeIn();	
		 $("body").scrollTop(0);	
	});
	
	$('.show-pop2').click(function(e){
		e.preventDefault();
		$('.login-error, .register-error').css('display', 'none');
		var i = $(this).attr('data-pop');
			l = $('#'+i);
		$('.popup, .popup-box').hide();
		$('.popup').attr('data-pop', i).fadeIn();
		l
		.fadeIn();		
		$("body").scrollTop(0);
	});

	$('.popup').click(function(e){
		e.preventDefault();
		var i = $(this).attr('data-pop');
		$(this).fadeOut();
		$('#'+i).fadeOut();
	});

	$('.faq-toggle').on('click', function(e){
    e.preventDefault();
    $(this).closest('.faq-container').toggleClass('active');
    $(this).find('.fa').toggleClass('fa-angle-down fa-angle-up');
});
});

$(window).load(function() {	
	header();
	list();
});

$(window).resize(function() {	
	header();
	list();
});

function header(){
	$('header').next('section').css('margin-top', $('header').height() );
	
	if($(window).width() > 911){
		$('#popmenu').hide();
	}
	
	$('#show-popmenu').click(function(e){
		e.preventDefault();
		$('#popmenu').slideDown('fast');
	});
	
	$('.close-popmenu').click(function(e){
		e.preventDefault();
		$(this).parents('#popmenu').slideUp('fast');
	});
}

function list(){
	if($(window).width() > 768){
		$('#list .thumb').each(function(){
			var h = $(this).next('div').height();
				i = $(this).height();
			$(this).find('img').css('margin-top', (h-i)/2 );
		});
	}
}

$('.faq-toggle').on('click', function(e){
    e.preventDefault();
    $(this).closest('.faq-container').toggleClass('active');
    $(this).find('.fa').toggleClass('fa-angle-down fa-angle-up');
});

//////////////// Sign Up ////////////////////
if($('.open-popup').length){
	$('.open-popup').magnificPopup({
		type:'inline',
		midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});
}

$("#paypal_submit").click(function(){
	$("#paypal_form_entry").submit();
});

$('#payment_wall_form_submit').click(function(){
	$('#payment_wall_form_entry').submit();
});
